export default __webpack_public_path__ + "static/media/simProfile-10.248162f1.png";